module.exports = __webpack_public_path__ + "static/inter-8f5d13cc289cab809aeed9571e230122.jpeg";